import axios from 'axios';
import jwtDefaultConfig from '../@core/auth/jwt/jwtDefaultConfig';

const env = process.env.NODE_ENV;

const URI =
  env === 'development'
    ? process.env.REACT_APP_DEVELOPMENT_API
    : process.env.REACT_APP_PRODUCTION_API;

const api = axios.create({
  baseURL: URI
});

api.interceptors.request.use(
  async (config) => {
    const token = localStorage.getItem(jwtDefaultConfig.storageTokenKeyName);
    if (token) {
      config.headers = {
        ...config.headers,
        authorization: `${jwtDefaultConfig.tokenType} ${token}`
      };
    }

    return config;
  },
  (error) => Promise.reject(error)
);

export default api;
